import React, { useState } from 'react';
import axios from 'axios';
import { Heart } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { API, setToken, fmtErr, useNoIndex } from '../lib/auth';

export default function AuthPage() {
  useNoIndex();
  const navigate = useNavigate();
  const [mode, setMode] = useState('login'); // login | signup | forgot
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(''); setInfo('');
    try {
      if (mode === 'forgot') {
        const { data } = await axios.post(`${API}/auth/forgot-password`, { email });
        setInfo(data.message);
      } else if (mode === 'signup') {
        const { data } = await axios.post(`${API}/auth/register`, { name, email, phone, password });
        setToken(data.token);
        navigate('/dashboard?tab=profile&welcome=1');
      } else {
        const { data } = await axios.post(`${API}/auth/login`, { email, password });
        setToken(data.token);
        navigate(data.user?.role === 'admin' ? '/admin' : '/');
      }
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail) || err.message);
    }
    setBusy(false);
  };

  return (
    <div className="admin-login-wrap">
      <form className="admin-login" onSubmit={submit} data-testid="auth-form">
        <Link to="/" className="al-logo" style={{ textDecoration: 'none' }}><Heart size={26} fill="var(--red)" color="var(--red)" /> Krysha</Link>
        <h2>{mode === 'signup' ? 'Create your account' : mode === 'forgot' ? 'Reset password' : 'Welcome back'}</h2>
        <p>
          {mode === 'signup' ? 'Get your unique Krysha ID and track your matches.' :
            mode === 'forgot' ? "We'll create a reset link for your account." :
              'Log in to your Krysha account.'}
        </p>

        {mode === 'signup' && (<>
          <label>Full Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" required data-testid="auth-name-input" />
        </>)}
        <label>Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required data-testid="auth-email-input" />
        {mode === 'signup' && (<>
          <label>Mobile / WhatsApp (Optional)</label>
          <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+91 98765 43210" data-testid="auth-phone-input" />
        </>)}
        {mode !== 'forgot' && (<>
          <label>Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required minLength={6} data-testid="auth-password-input" />
        </>)}

        {error && <div className="al-error" data-testid="auth-error">{error}</div>}
        {info && <div className="al-info" data-testid="auth-info">{info}</div>}

        <button className="btn btn-red" type="submit" disabled={busy} data-testid="auth-submit-btn">
          {busy ? 'Please wait…' : mode === 'signup' ? 'Create Account' : mode === 'forgot' ? 'Create Reset Link' : 'Log In'}
        </button>

        <div className="auth-links">
          {mode !== 'login' && <button type="button" onClick={() => { setMode('login'); setError(''); setInfo(''); }} data-testid="switch-to-login">Log in instead</button>}
          {mode !== 'signup' && <button type="button" onClick={() => { setMode('signup'); setError(''); setInfo(''); }} data-testid="switch-to-signup">Create an account</button>}
          {mode === 'login' && <button type="button" onClick={() => { setMode('forgot'); setError(''); setInfo(''); }} data-testid="switch-to-forgot">Forgot password?</button>}
        </div>
        <p className="auth-privacy">Your email and mobile number are never shown publicly. Guests can always <Link to="/#match" style={{ color: 'var(--red)' }}>submit the form without an account</Link>.</p>
      </form>
    </div>
  );
}
